import React, { useCallback, useEffect, useState } from 'react';
import InputField from '../../component/form/FormInput';
import Button from '../../component/ui/Button';
import { useBlocker, useLocation, useNavigate, useParams } from 'react-router-dom';
import InputSelect from '../../component/inputSelect/InputSelect';
import './CreditNote.scss';
import tooltipIcon from '../../assets/image/tooltip_vendor name.png';
import CreditNoteTable from './CreditNoteTable';
import VendorDetailsDrawer from '../purchaseOrder/components/VendorDetailsDrawer';
import { fetchVendors } from '../../services/vendor';
import { toast } from 'react-toastify';
import {
	create_credit_note,
	fetchCreditNoteDetails,
	fetchExcessPaymentCreditNoteDetails,
	update_credit_note,
} from '../../services/credit_note';
import { getCurrentDate, getDate } from '../../utils/dateUtils';
import Modal from '../../component/modal/Modal';
import AppendInput from '../../component/form/AppendInput';
import AddVendorModal from '../purchaseOrder/AddNewVendor';
import PaymentMadeProductTable from '../paymentMade/components/paymentMadeProductTable';
import PageLoader from '../../component/PageLoader';
import { useSelector } from 'react-redux';
import { hasPermission } from '../../utils/controller';
import AutoSaveModal from '../components/autoSaveModal';

const CreateCreditNote = () => {
	const today = new Date().toISOString().split('T')[0];
	const suburl = localStorage.getItem('suburl');
	const [isVendorDetailsDrawerOpen, setIsVendorDetailsDrawerOpen] = useState(false);
	const [isAddNewVendorModalOpen, setIsAddNewVendorModalOpen] = useState(false);
	const param = useParams();
	const id = param?.id;
	const navigate = useNavigate();
	const [autofocus, setAutofocus] = useState(false);
	const [disabled, setDisabled] = useState(false);
	const [TableError, setTableError] = useState(false);
	const [isExcessPaymentLoading, setExcessPaymentLoading] = useState(false);
	const [vendorDetails, setVendorDetails] = useState(null);
	const [errorCells, setErrorCells] = useState([]);
	const [error, setError] = useState({});
	const [vendorDetailsDrawerActiveOpenTab, setVendorDetailsDrawerActiveOpenTab] = useState('');
	const [isNextLocation, setIsNextLocation] = useState(null);
	const [isLocationBlocker, setIsLocationBlocker] = useState(true);
	const [isCreditNoteAutoSave, setIsCreditNoteAutoSave] = useState(false);
	const user = useSelector((state) => state?.userInfo?.userInfo?.data);
	const [inputSelectOption, setInputSelectOption] = useState({
		vendorList: [],
	});
	const [creditNoteTypeList, setCreditNoteTypeList] = useState([
		{ key: 1, value: 'Damaged/Return Goods' },
		{ key: 2, value: 'Excess Payment' },
		{ key: 3, value: 'Advance Payment' },
	]);
	const location = useLocation();
	const [additionDiscountAndTax, setAdditionDiscountAndTax] = useState({
		discount: '',
		adj: '',
		roundOff: 0,
	});
	const [subTotal, setSubTotal] = useState(0);
	const [taxTotal, setTaxTotal] = useState(0);
	const [loading, setLoading] = useState({
		isLoading: false,
		status: null,
	});

	const [creditNoteFormData, setCreditNoteFormData] = useState({
		vendor_id: null,
		credit_note_type: 1,
		credit_note_number: '',
		date: today,
		credit_note_date: today,
		reference_number: '',
		payment_amount: '',
		credit_note_amount: '',
		notes: '',
		credit_note_products: [],
		credit_note_excess_bills: [],
	});
	const [params, setParams] = useState({
		vendor: {
			status: 1,
			page: 1,
			pageSize: 20,
			orderBy: null,
			sortBy: null,
			filterBy: null,
			filterValue: null,
			filter: {
				status: '1',
			},
		},
	});

	const [isOpenPastDate, setIsOpenPastDate] = useState(false);
	const [isUsedPastDate, setIsUsedPastDate] = useState(false);
	const [isOpenCNPastDate, setIsOpenCNPastDate] = useState(false);
	const [isUsedCNPastDate, setIsUsedCNPastDate] = useState(false);
	const [isCreditNoteDateFocus, setIsCreditNoteFocus] = useState(false);
	const [isReferenceFocus, setIsReferenceFocus] = useState(false);
	const [projectTitle, setProjectTitle] = useState('Create New Credit Note');

	const confirmUsedPastDate = () => {
		const newError = { ...error };
		delete newError.date;
		setError(newError);
		setIsUsedPastDate(true);
		setIsOpenPastDate(false);
		setIsCreditNoteFocus(true);
	};
	const confirmUsedCNPastDate = () => {
		const newError = { ...error };
		delete newError.credit_note_date;
		setError(newError);
		setIsUsedCNPastDate(true);
		setIsOpenCNPastDate(false);
		setIsReferenceFocus(true);
	};

	const cancelUsedPastDate = () => {
		if (isOpenPastDate) {
			setIsOpenPastDate(false);
			setIsCreditNoteFocus(true);
		} else {
			setIsOpenCNPastDate(false);
			setIsReferenceFocus(true);
		}
	};
	function handleClearAppliedAmount() {
		if (disabled) return;
		const paymentBillsData = creditNoteFormData.credit_note_excess_bills.map((item) => ({
			...item,
			excess_paid_amount: 0,
		}));
		setCreditNoteFormData((prev) => ({
			...prev,
			credit_note_excess_bills: paymentBillsData,
		}));
	}

	const handlePaymentChange = (index, value) => {
		const paymentBillsData = [...creditNoteFormData.credit_note_excess_bills];
		paymentBillsData[index].excess_paid_amount = value;

		setCreditNoteFormData((prev) => ({
			...prev,
			credit_note_excess_bills: paymentBillsData,
		}));

		const isValid =
			Number(paymentBillsData[index].due_amount) - Number(paymentBillsData[index].bill_amount) >=
			Number(value);
		setErrorCells((prev) => {
			const filtered = prev.filter((error) => error.index !== index);
			return isValid ? filtered : [...filtered, { index, error: 'Invalid Amount' }];
		});
	};

	const handleFullPaymentToggle = (index, type) => {
		if (type === 'pay') {
			const paymentBillsData = [...creditNoteFormData.credit_note_excess_bills];

			if (
				Number(paymentBillsData[index].due_amount) === Number(paymentBillsData[index].bill_amount)
			) {
				toast.error('Payment amount is already paid.');
				return;
			}

			paymentBillsData[index].excess_paid_amount =
				paymentBillsData[index].due_amount - paymentBillsData[index].bill_amount;
			setCreditNoteFormData((prev) => ({
				...prev,
				credit_note_excess_bills: paymentBillsData,
			}));
		} else {
			const paymentBillsData = [...creditNoteFormData.credit_note_excess_bills];

			paymentBillsData[index].excess_paid_amount = 0.0;
			setCreditNoteFormData((prev) => ({
				...prev,
				credit_note_excess_bills: paymentBillsData,
			}));
		}
	};

	const calculateTotalPayment = () => {
		return creditNoteFormData?.credit_note_excess_bills
			? creditNoteFormData?.credit_note_excess_bills?.reduce(
				(total, bill) => Number(total) + Number(bill.excess_paid_amount),
				0,
			)
			: 0;
	};

	async function handleFetchVendorList() {
		try {
			const { vendors } = await fetchVendors(params?.vendor);
			const vendorOptionList = vendors?.map((vendor) => {
				return {
					key: vendor?.vendor_id,
					value: vendor?.vendor_name,
				};
			});
			if (creditNoteFormData.vendor_id) {
				const isVendorFound = vendorOptionList.find(
					(vendor) => vendor.key === creditNoteFormData.vendor_id,
				);
				if (!isVendorFound) {
					setParams((prev) => ({
						...prev,
						vendor: {
							filterBy: 'vendor_id',
							filterValue: Number(creditNoteFormData.vendor_id),
						},
					}));
				}
			} else {
				setInputSelectOption((prev) => ({
					vendorList: vendorOptionList,
				}));
			}
			setVendorDetails(vendors);
		} catch (error) {
			toast.error('Something went wrong!');
		}
	}

	function handleKeyPress(name, e) {
		let { value } = e.target;
		if (e.key === 'Enter' || e.key === 'Tab') {
			handleFormData(name, value);
		}
	}

	function handleFormData(key, value) {
		setCreditNoteFormData((prev) => ({
			...prev,
			[key]: value,
		}));

		let errorData = { ...error };

		if (key === 'vendor_id' && (value === '' || value === null)) {
			errorData.vendor_id = 'Please select a valid vendor in the list';
		} else if (key === 'vendor_id' && (value !== '' || value !== null)) {
			delete errorData.vendor_id;
		}

		if (key === 'credit_note_type' && (value === '' || value === null)) {
			errorData.credit_note_type = 'Please select a valid credit note type in the list';
		} else if (key === 'credit_note_type' && (value !== '' || value !== null)) {
			delete errorData.credit_note_type;
		}
		if (key === 'credit_note_number' && (value === '' || value === null)) {
			errorData.credit_note_number = 'Please enter credit note number in the field';
		} else if (key === 'credit_note_number' && (value !== '' || value !== null)) {
			delete errorData.credit_note_number;
		}

		if (key === 'date' && (value === '' || value === null)) {
			errorData.date = 'Please enter date in the field';
		} else if (key === 'date' && (value !== '' || value !== null)) {
			delete errorData.date;
		}

		if (key === 'credit_note_date' && (value === '' || value === null)) {
			errorData.credit_note_date = 'Please enter credit note date in the field';
		} else if (key === 'credit_note_date' && (value !== '' || value !== null)) {
			delete errorData.credit_note_date;
		}
		setError(errorData);
	}

	function checkValidation(status) {
		const newError = { ...error };
		if (
			!creditNoteFormData.vendor_id ||
			creditNoteFormData.vendor_id === '' ||
			creditNoteFormData.vendor_id === undefined
		) {
			newError.vendor_id = 'Please select a valid vendor name in the list';
		} else {
			delete newError.vendor_id;
		}
		if (
			!creditNoteFormData.credit_note_type ||
			creditNoteFormData.credit_note_type === '' ||
			creditNoteFormData.credit_note_type === undefined
		) {
			newError.credit_note_type = 'Please select a valid credit note type in the list';
		} else {
			delete newError.credit_note_type;
		}
		if (
			!creditNoteFormData.credit_note_number ||
			creditNoteFormData.credit_note_number === '' ||
			creditNoteFormData.credit_note_number === undefined
		) {
			newError.credit_note_number = 'Please enter credit note number in the field';
		} else {
			delete newError.credit_note_number;
		}
		if (
			!creditNoteFormData.date ||
			creditNoteFormData.date === '' ||
			creditNoteFormData.date === undefined ||
			(creditNoteFormData.date !== '' && newError.date)
		) {
			newError.date = newError.date ?? 'Please enter date in the field';
		} else {
			delete newError.date;
		}

		if (
			!creditNoteFormData.credit_note_date ||
			creditNoteFormData.credit_note_date === '' ||
			creditNoteFormData.credit_note_date === undefined ||
			(creditNoteFormData.credit_note_date !== '' && newError.credit_note_date)
		) {
			newError.credit_note_date =
				newError.credit_note_date ?? 'Please enter  credit note date in the field';
		} else {
			delete newError.credit_note_date;
		}

		if (status === 1) {
			if (
				creditNoteFormData?.credit_note_type &&
				Number(creditNoteFormData?.credit_note_type) === 1
			) {
				let newErrorCell = [...errorCells];
				if (creditNoteFormData.credit_note_products.length > 0) {
					let productIndex = Number(creditNoteFormData.credit_note_products.length) - 1;
					if (creditNoteFormData.credit_note_products[productIndex].product_id === '') {
						newErrorCell = [...newErrorCell, { index: productIndex, name: 'product_id' }];
						newError.product_id = '';
					} else {
						delete newError.product_id;
					}
					if (
						creditNoteFormData.credit_note_products[productIndex].batch_no === '' ||
						creditNoteFormData.credit_note_products[productIndex].batch_no === null
					) {
						newErrorCell = [...newErrorCell, { index: productIndex, name: 'batch_no' }];
						newError.batch_no = '';
					} else {
						delete newError.batch_no;
					}
					if (
						creditNoteFormData.credit_note_products[productIndex].quantity === '' ||
						creditNoteFormData.credit_note_products[productIndex].quantity === null ||
						Number(creditNoteFormData.credit_note_products[productIndex].quantity) === 0
					) {
						newErrorCell = [...newErrorCell, { index: productIndex, name: 'quantity' }];
						newError.quantity = '';
					} else {
						delete newError.quantity;
					}

					if (
						creditNoteFormData.credit_note_products[productIndex].rate === '' ||
						creditNoteFormData.credit_note_products[productIndex].rate === null ||
						Number(creditNoteFormData.credit_note_products[productIndex].rate) === 0
					) {
						newErrorCell = [...newErrorCell, { index: productIndex, name: 'rate' }];
						newError.rate = '';
					} else {
						delete newError.rate;
					}

					if (
						creditNoteFormData.credit_note_products[productIndex].mfg_date === '' ||
						creditNoteFormData.credit_note_products[productIndex].mfg_date === null
					) {
						newErrorCell = [...newErrorCell, { index: productIndex, name: 'mfg_date' }];
						newError.mfg_date = '';
					} else {
						delete newError.mfg_date;
					}

					if (
						creditNoteFormData.credit_note_products[productIndex].exp_date === '' ||
						creditNoteFormData.credit_note_products[productIndex].exp_date === null
					) {
						newErrorCell = [...newErrorCell, { index: productIndex, name: 'exp_date' }];
						newError.exp_date = '';
					} else {
						delete newError.exp_date;
					}

					if (
						creditNoteFormData.credit_note_products[productIndex].mrp === '' ||
						creditNoteFormData.credit_note_products[productIndex].mrp === null ||
						Number(creditNoteFormData.credit_note_products[productIndex].mrp) === 0
					) {
						newErrorCell = [...newErrorCell, { index: productIndex, name: 'mrp' }];
						newError.mrp = '';
					} else {
						delete newError.mrp;
					}
				} else {
					newErrorCell = [...newErrorCell, { index: 0, name: 'product_id' }];
					newError.product_id = '';
					newErrorCell = [...newErrorCell, { index: 0, name: 'batch_no' }];
					newError.batch_no = '';
					newErrorCell = [...newErrorCell, { index: 0, name: 'quantity' }];
					newError.quantity = '';
					newErrorCell = [...newErrorCell, { index: 0, name: 'rate' }];
					newError.rate = '';
					newErrorCell = [...newErrorCell, { index: 0, name: 'mfg_date' }];
					newError.mfg_date = '';
					newErrorCell = [...newErrorCell, { index: 0, name: 'exp_date' }];
					newError.exp_date = '';
					newErrorCell = [...newErrorCell, { index: 0, name: 'mrp' }];
					newError.mrp = '';
				}
				setErrorCells(newErrorCell);
			} else if (Number(creditNoteFormData?.credit_note_type) === 3) {
				setErrorCells([]);
			}
		} else {
			delete newError.product_id;
			delete newError.batch_no;
			delete newError.quantity;
			delete newError.rate;
			delete newError.mfg_date;
			delete newError.exp_date;
		}

		if (
			Object.keys(newError).length > 0 ||
			(status === 1 && TableError) ||
			(status === 1 && errorCells.length > 0)
		) {
			setError(newError);
			return true;
		} else {
			return false;
		}
	}

	async function handleSaveCreditNote(status) {
		const isErrorShow = checkValidation(status);
		if (isErrorShow) {
			toast.error('Unable to create or update credit note');
		} else {
			try {
				setLoading((prev) => ({
					...prev,
					isLoading: true,
					status: status,
				}));
				const body = {
					...creditNoteFormData,
					status,
					discount: Number(additionDiscountAndTax.discount),
					adjustment: Number(additionDiscountAndTax.adj),
					bill_total:
						creditNoteFormData?.credit_note_type === 1
							? totalAmount().toFixed(2)
							: creditNoteFormData?.credit_note_type === 2
								? calculateTotalPayment().toFixed(2)
								: 0,
					credit_note_products:
						Number(creditNoteFormData?.credit_note_type) === 1
							? creditNoteFormData?.credit_note_products
								.filter(
									(product) =>
										product.product_id !== '' &&
										product.product_id !== null &&
										product.quantity !== 0 &&
										product.quantity !== null &&
										product.quantity !== '' &&
										product.mrp !== 0 &&
										product.mrp !== null &&
										product.mrp !== '' &&
										product.rate !== 0 &&
										product.rate !== null &&
										product.rate !== '' &&
										product.amount !== 0 &&
										product.amount !== null &&
										product.amount !== '',
								)
								.map((prod) => {
									const { tax, quantity, mrp, rate, amount, ...rest } = prod;
									return {
										...rest,
										quantity: Number(quantity),
										tax: tax === '' || tax === null ? 0 : Number(tax),
										mrp: Number(mrp),
										rate: Number(rate),
										amount: Number(amount),
									};
								})
							: [],
					credit_note_excess_bills:
						Number(creditNoteFormData?.credit_note_type) === 2
							? creditNoteFormData?.credit_note_excess_bills.map((prod) => {
								const { excess_paid_amount, ...rest } = prod;
								return {
									...rest,
									excess_paid_amount: Number(excess_paid_amount),
								};
							})
							: [],
				};
				if ((id && id.includes('purchase-bill')) || !id) {
					await create_credit_note(body);
					toast.success('Credit Note Created Successfully');
				} else if (id) {
					await update_credit_note(id, body);
					toast.success('Credit Note updated Successfully');
				}
				setIsLocationBlocker(false);
				setIsCreditNoteAutoSave(false);
				setTimeout(() => {
					navigate(`/user/${suburl}/credit-note`);
				}, 300);
			} catch (error) {
				toast.error(error?.message || 'Something went wrong!');
			} finally {
				setLoading((prev) => ({
					...prev,
					isLoading: false,
					status: status,
				}));
			}
		}
	}

	async function handleFetchCreditNoteDetails() {
		setProjectTitle('Update Credit Note');
		try {
			const creditNoteDetails = await fetchCreditNoteDetails(id);
			const {
				credit_note_id,
				vendor_id,
				credit_note_number,
				date,
				credit_note_type,
				credit_note_date,
				reference_number,
				notes,
				discount,
				adjustment,
			} = creditNoteDetails;

			setCreditNoteFormData({
				credit_note_id,
				vendor_id,
				credit_note_type,
				credit_note_number,
				date: getDate(date, true),
				credit_note_date: getDate(credit_note_date, true),
				reference_number,
				notes,
				...(Number(credit_note_type === 1)
					? {
						credit_note_products:
							creditNoteDetails?.redit_note_products &&
								creditNoteDetails?.credit_note_products?.length === 0
								? []
								: creditNoteDetails?.credit_note_products?.map((cnp) => {
									return {
										credit_note_products_id: cnp?.credit_note_products_id,
										credit_note_id: cnp?.credit_note_id,
										product_id: cnp?.product_id,
										batch_no: cnp?.batch_no,
										quantity: cnp?.quantity,
										exp_date: getDate(cnp?.exp_date, true, true),
										mfg_date: getDate(cnp?.mfg_date, true, true),
										mrp: cnp?.mrp,
										rate: cnp?.rate,
										tax: cnp?.tax,
										amount: cnp?.amount,
									};
								}),
					}
					: Number(credit_note_type) === 2
						? {
							credit_note_excess_bills:
								creditNoteDetails?.credit_note_excess_bills &&
									creditNoteDetails?.credit_note_excess_bills.length > 0
									? creditNoteDetails?.credit_note_excess_bills?.map((cnp) => ({
										purchase_bill_id: cnp?.purchase_bill_id,
										date: getDate(cnp?.purchase_bill?.bill_date) || '',
										due_date: getDate(cnp?.purchase_bill?.due_date) || '',
										bill_number: cnp?.purchase_bill?.bill_number,
										purchase_order_number: cnp?.purchase_bill?.purchase_order_number,
										bill_amount: cnp?.purchase_bill?.bill_amount,
										due_amount: cnp?.purchase_bill?.paid_amount,
										excess_paid_amount: cnp.excess_paid_amount || 0,
									}))
									: [],
						}
						: { payment_amount: Number(creditNoteDetails.payment_amount) }),
			});
			if (credit_note_type === 1) {
				setAdditionDiscountAndTax((prev) => ({
					...prev,
					discount: Number(discount),
					adj: Number(adjustment),
				}));
			}
		} catch (e) {
			toast.error('Something went wrong!');
		}
	}
	async function handleFetchExcessPaymentCreditNoteDetails(vendorId) {
		try {
			setExcessPaymentLoading(true);
			const excessPaymentcreditNoteDetails = await fetchExcessPaymentCreditNoteDetails(vendorId);
			if (id && id.includes('purchase-bill')) {
				var data = excessPaymentcreditNoteDetails?.excess_bills.filter(
					(pb) => pb?.purchase_bill_id.toString() === id.split('=')[1].toString(),
				);
				setCreditNoteFormData((prev) => ({
					...prev,
					credit_note_excess_bills: data.map((cnp) => {
						return {
							purchase_bill_id: cnp?.purchase_bill_id,
							date: getDate(cnp?.bill_date) || '',
							due_date: getDate(cnp?.due_date) || '',
							bill_number: cnp?.bill_number,
							purchase_order_number:
								cnp?.purchase_order_number || cnp?.purchase_order?.purchase_order_number,
							bill_amount: cnp?.bill_amount,
							due_amount: cnp?.paid_amount,
							excess_paid_amount: cnp.excess_paid_amount || '',
						};
					}),
				}));
			} else {
				setCreditNoteFormData((prev) => ({
					...prev,
					credit_note_excess_bills: excessPaymentcreditNoteDetails?.excess_bills.map((cnp) => {
						return {
							purchase_bill_id: cnp?.purchase_bill_id,
							date: getDate(cnp?.bill_date) || '',
							due_date: getDate(cnp?.due_date) || '',
							bill_number: cnp?.bill_number,
							purchase_order_number:
								cnp?.purchase_order_number || cnp?.purchase_order?.purchase_order_number,
							bill_amount: cnp?.bill_amount,
							due_amount: cnp?.paid_amount,
							excess_paid_amount: cnp.excess_paid_amount || '',
						};
					}),
				}));
			}
		} catch (e) {
			toast.error(e);
		} finally {
			setExcessPaymentLoading(false);
		}
	}

	const navigateRouter = (path) => {
		navigate(path);
	};

	function totalAmount() {
		const totalAmount = Number(subTotal) + Number(taxTotal);
		return (
			Number(totalAmount) -
			(Number(totalAmount) * Number(additionDiscountAndTax.discount)) / 100 +
			Number(additionDiscountAndTax.adj)
		);
	}

	const handleBillTotal = useCallback(
		(credit_note_products) => {
			const totalAmountWithTax = credit_note_products?.reduce(
				(sum, item) => Number(sum) + Number(item.amount),
				0,
			);
			const totalAmountTax = credit_note_products?.reduce(
				(sum, item) =>
					Number(sum) + (Number(item.tax) * Number(item.quantity) * Number(item.rate)) / 100,
				0,
			);

			setTaxTotal(totalAmountTax);
			setSubTotal(totalAmountWithTax - totalAmountTax);
		},
		[creditNoteFormData?.credit_note_products],
	);

	useEffect(() => {
		if (id) {
			if (id.includes('purchase-bill')) {
				handleFormData('credit_note_type', 2);
				setTableDataByCreditNoteType(2, location.state.key.toString());
			} else {
				handleFetchCreditNoteDetails();
			}
		}
	}, [id]);

	useEffect(() => {
		handleFetchVendorList();
	}, [params.vendor, id]);

	useEffect(() => {
		if (creditNoteFormData?.credit_note_products?.length > 0) {
			handleBillTotal(creditNoteFormData?.credit_note_products);
		}
	}, [creditNoteFormData?.credit_note_products]);

	function setVendorData() {
		if (location && location?.state) {
			const state = location?.state;
			setInputSelectOption((prev) => ({
				...prev,
				vendorList: [state],
			}));
			setCreditNoteFormData((prev) => ({
				...prev,
				vendor_id: state?.key,
			}));
		}
	}

	const setTableDataByCreditNoteType = (type, vendorId) => {
		if (type === 1) {
			setCreditNoteFormData((prev) => ({
				...prev,
				credit_note_products: [],
			}));
		} else if (type === 2) {
			handleFetchExcessPaymentCreditNoteDetails(vendorId.toString());
		} else {
			setCreditNoteFormData((prev) => ({
				...prev,
				credit_note_products: [],
			}));
		}
	};

	useEffect(() => {
		if (location && location?.state) {
			setVendorData();
		}
	}, [location]);

	useEffect(() => {
		if (creditNoteFormData?.credit_note_type && creditNoteFormData?.vendor_id && !id) {
			setTableDataByCreditNoteType(
				creditNoteFormData?.credit_note_type,
				creditNoteFormData?.vendor_id,
			);
		}
	}, [creditNoteFormData?.credit_note_type, creditNoteFormData?.vendor_id]);

	useEffect(() => {
		document.title = `${projectTitle} | Pharmnex`;
	}, [projectTitle]);

	useBlocker((tx) => {
		if (!id && isLocationBlocker) {
			setIsNextLocation(tx);
			setIsCreditNoteAutoSave(true);
			return true;
		}
		return false;
	});
	useEffect(() => {
		if (!autofocus) {
			setAutofocus(true);
		}
	}, [autofocus]);

	return (
		<div>
			<div className="product-pg-header add-product header-position-sticky">
				<p>{id ? 'Update Credit Note' : 'Create New Credit Note'}</p>
				<div className="add-product-button">
					{/* <Button
							type="button"
							className="mt-0 px-4 btn-primary"
							button="Save as Draft"
							loader={loading?.status === 0 && loading.isLoading}
							onClick={() => {
								setIsCreditNoteAutoSave(false);
								handleSaveCreditNote(0);
							}}
						/> */}
					<Button
						type="button"
						className="mt-0 px-4 btn-primary"
						button="Save as Open"
						disabled={
							loading?.status === 1 && loading.isLoading
								? true
								: id
									? !hasPermission('purchases.credit_notes.edit', user?.role?.role_permissions)
									: !hasPermission('purchases.credit_notes.create', user?.role?.role_permissions)
						}
						loader={loading?.status === 1 && loading.isLoading}
						onClick={() => {
							setIsCreditNoteAutoSave(false);
							handleSaveCreditNote(1);
						}}
					/>
					<Button
						type="button"
						className="mt-0 btn-danger add-pro"
						button=""
						close
						onClick={() => navigateRouter(`/user/${suburl}/credit-note`)}
					/>
				</div>
			</div>

			{/*  Vendor Form */}
			<div className="purchase-bill-content">
				<div className="max-w-1297 px-3 py-3">
					<div className="row">
						<div className="col">
							<InputSelect
								label="Credit Note Type"
								placeholder="Select Credit Note Type"
								required={true}
								options={creditNoteTypeList}
								returnInputValue={false}
								value={creditNoteFormData?.credit_note_type}
								onSelect={(option) => {
									handleFormData('credit_note_type', option.key);
									setErrorCells([]);
								}}
								onChange={(value) => { }}
								error={error?.credit_note_type}
								autoFocus={true}
								disabled={id ? true : disabled}
							/>
						</div>
						<div className="col">
							<InputSelect
								label="Vendor Name"
								placeholder="Vendor Name"
								required={true}
								options={inputSelectOption.vendorList}
								returnInputValue={false}
								value={creditNoteFormData?.vendor_id}
								onAddNew={() => setIsAddNewVendorModalOpen(true)}
								onSelect={(option) => {
									handleFormData('vendor_id', option.key);
									setParams((prev) => ({
										...prev,
										vendor: {
											...prev.vendor,
											filterBy: 'vendor_id',
											filterValue: option.key,
										},
									}));
								}}
								onChange={(value) => {
									if (value === '') {
										handleFormData('vendor_id', value);
									}
									setParams((prev) => ({
										...prev,
										vendor: {
											...prev.vendor,
											filterBy: 'vendor_name',
											filterValue: value,
										},
									}));
								}}
								leftIcons={
									creditNoteFormData?.vendor_id
										? [
											{
												src: tooltipIcon,
												alt: 'Icon 2',
												onClick: () => {
													setVendorDetailsDrawerActiveOpenTab('Details');
													setIsVendorDetailsDrawerOpen(true);
												},
											},
										]
										: []
								}
								error={error?.vendor_id}
								autoFocus={autofocus}
								disabled={id ? true : disabled}
							/>
						</div>

						<div className="col">
							<InputField
								label="Credit Note #"
								placeholder="Credit Note #"
								type="text"
								required={true}
								onKeyPress={(e) => handleKeyPress('credit_note_number', e)}
								onChange={(value) => handleFormData('credit_note_number', value)}
								value={creditNoteFormData.credit_note_number}
								error={error?.credit_note_number}
								disabled={disabled}
							/>
						</div>
					</div>
					<div className="row">
						<div className="col">
							<InputField
								label="Date"
								placeholder="dd/mm/yyyy"
								type="date"
								value={creditNoteFormData.date}
								onBlur={(e) => {
									let value = e.target.value;
									const newError = { ...error };
									var date = new Date(value);
									var currentDate = new Date();
									currentDate.setDate(currentDate.getDate() + 1);
									let year = date.getFullYear().toString();
									if (year.length === 4 && new Date(value) < new Date().setHours(0, 0, 0, 0)) {
										if (!isUsedPastDate) {
											setIsOpenPastDate(true);
											newError.date = 'Date cannot be in the past.';
											setError(newError);
										} else {
											delete newError.date;
											setError(newError);
										}
										setCreditNoteFormData((prev) => ({
											...prev,
											date: value,
										}));
									} else if (
										year.length === 4 &&
										new Date(value) > currentDate.setHours(0, 0, 0, 0)
									) {
										setIsOpenPastDate(false);
										newError.date = 'Date cannot be in the future';
										setError(newError);
										setCreditNoteFormData((prev) => ({
											...prev,
											date: value,
										}));
									} else {
										setIsOpenPastDate(false);
										delete newError.date;
										setError(newError);
										setCreditNoteFormData((prev) => ({
											...prev,
											date: value,
										}));
									}
								}}
								max={getCurrentDate()}
								onChange={(value) => {
									setCreditNoteFormData((prev) => ({
										...prev,
										date: value,
									}));
								}}
								required={true}
								error={error?.date}
								disabled={disabled}
							/>
						</div>
						<div className="col">
							<InputField
								label="Credit Note Date"
								placeholder="dd/mm/yyyy"
								type="date"
								autoFocus={isCreditNoteDateFocus}
								value={creditNoteFormData.credit_note_date}
								onBlur={(e) => {
									let value = e.target.value;
									const newError = { ...error };
									var date = new Date(value);
									var currentDate = new Date();
									currentDate.setDate(currentDate.getDate() + 1);
									let year = date.getFullYear().toString();
									if (year.length === 4 && new Date(value) < new Date().setHours(0, 0, 0, 0)) {
										if (!isUsedCNPastDate) {
											setIsOpenCNPastDate(true);
											newError.credit_note_date = 'Credit note date cannot be in the past.';
											setError(newError);
										} else {
											delete newError.credit_note_date;
											setError(newError);
										}
										setCreditNoteFormData((prev) => ({
											...prev,
											credit_note_date: value,
										}));
									} else if (
										year.length === 4 &&
										new Date(value) > currentDate.setHours(0, 0, 0, 0)
									) {
										setIsOpenCNPastDate(false);
										newError.credit_note_date = 'Credit note date cannot be in the future';
										setError(newError);
										setCreditNoteFormData((prev) => ({
											...prev,
											credit_note_date: value,
										}));
									} else {
										setIsOpenCNPastDate(false);
										delete newError.credit_note_date;
										setError(newError);
										setCreditNoteFormData((prev) => ({
											...prev,
											credit_note_date: value,
										}));
									}
								}}
								max={getCurrentDate()}
								onChange={(value) => {
									setCreditNoteFormData((prev) => ({
										...prev,
										credit_note_date: value,
									}));
								}}
								required={true}
								error={error?.credit_note_date}
							/>
						</div>
						<div className="col">
							<InputField
								label="References # "
								placeholder="Ref-00005"
								type="text"
								value={creditNoteFormData.reference_number}
								onChange={(value) =>
									setCreditNoteFormData((prev) => ({
										...prev,
										reference_number: value,
									}))
								}
								disabled={disabled}
								autoFocus={isReferenceFocus}
							/>
						</div>
					</div>
					<div
						className="row"
						style={{ paddingTop: '10px' }}
					>
						{creditNoteFormData?.credit_note_type === 3 && (
							<div style={{ width: '33%' }}>
								<AppendInput
									label="Payment Amount"
									placeholder="Amount"
									appendLabel="INR"
									required={true}
									type="text"
									className="custom-append-text"
									error={error?.payment_amount}
									value={creditNoteFormData?.payment_amount}
									onChange={(value) => {
										handleFormData('payment_amount', value);
									}}
								/>
							</div>
						)}
						<div className="col">
							<InputField
								label="Notes "
								placeholder="Notes"
								type="text"
								value={creditNoteFormData.notes}
								onChange={(value) =>
									setCreditNoteFormData((prev) => ({
										...prev,
										notes: value,
									}))
								}
								disabled={disabled}
							/>
						</div>
					</div>
				</div>

				{/* Credit Note Table */}
				{creditNoteFormData?.credit_note_type === 1 ? (
					<CreditNoteTable
						tableData={creditNoteFormData.credit_note_products}
						setTableData={(data) => {
							setCreditNoteFormData((prev) => ({
								...prev,
								credit_note_products: data,
							}));
							handleBillTotal(data);
						}}
						disabled={disabled}
						paramId={id}
						tableError={TableError}
						setIsTableErrorShow={setTableError}
						errorCells={errorCells}
						setErrorCells={setErrorCells}
					/>
				) : creditNoteFormData?.credit_note_type === 2 ? (
					isExcessPaymentLoading ? (
						<PageLoader />
					) : creditNoteFormData?.credit_note_excess_bills.length > 0 ? (
						<PaymentMadeProductTable
							id={id}
							isDisabled={disabled}
							type="cn"
							tableColumns={['Bill#', 'PO#', 'Bill Amount', 'Amount Paid', 'Excess Paid Amount']}
							productTableData={creditNoteFormData?.credit_note_excess_bills}
							errors={errorCells}
							handlePaymentChange={handlePaymentChange}
							handleFullPaymentToggle={handleFullPaymentToggle}
							calculateTotalPayment={calculateTotalPayment}
							handleClearAppliedAmount={handleClearAppliedAmount}
						/>
					) : (
						<div
							style={{
								display: 'flex',
								alignItems: 'center',
								justifyContent: 'center',
								paddingY: '20px',
							}}
						>
							<p>No open bills for this vendor.</p>
						</div>
					)
				) : (
					<></>
				)}
			</div>
			<br />

			<div className="total-bill-footer">
				{creditNoteFormData?.credit_note_type === 1 && (
					<div
						style={{
							border: '1px solid #C3CBDC',
							backgroundColor: '#DADDEC',
							alignItems: 'center',
						}}
					>
						<div className="max-w-1297 px-3 pt-3">
							<div className="TotalBillDivCredit">
								<div style={{ textAlign: 'right' }}>
									<p style={{ marginBottom: '16px', marginTop: '10px' }}>Discount</p>
									<p style={{ marginBottom: '20px', marginTop: '25px' }}>Adjustment</p>
									<p>Sub Total</p>
									<p>Taxes</p>
									<p>Bill Total </p>
								</div>
								<div style={{ textAlign: 'left' }}>
									<p>
										<AppendInput
											label=""
											placeholder="0"
											appendLabel="%"
											type="text"
											className="custom-append-text"
											error={error?.payment_amount}
											value={additionDiscountAndTax?.discount}
											onChange={(valueData) => {
												let value = valueData?.replace(/[^0-9.]/g, '');
												const decimalCount = (value.match(/\./g) || []).length;
												if (decimalCount > 1) {
													value = +value?.slice(0, value.lastIndexOf('.'));
												}
												setAdditionDiscountAndTax((prev) => ({
													...prev,
													discount: value,
												}));
											}}
										/>
									</p>
									<p>
										<InputField
											value={additionDiscountAndTax.adj}
											type="number"
											onChange={(value) => {
												setAdditionDiscountAndTax((prev) => ({
													...prev,
													adj: value,
												}));
											}}
											placeholder="0.00"
										/>
									</p>
									<p>₹{subTotal.toFixed(2)}/-</p>
									<p>₹{taxTotal.toFixed(2)}/-</p>
									<p>
										₹{totalAmount().toFixed(2)}
										/-
									</p>
								</div>
							</div>
						</div>
					</div>
				)}
			</div>

			{isAddNewVendorModalOpen && (
				<AddVendorModal
					handleFormData={handleFormData}
					vendorList={inputSelectOption.vendorList}
					setVendorList={(value) =>
						setInputSelectOption((prev) => ({
							...prev,
							vendorList: value,
						}))
					}
					onClose={() => setIsAddNewVendorModalOpen(false)}
				/>
			)}

			{
				<VendorDetailsDrawer
					isOpen={isVendorDetailsDrawerOpen}
					onClose={() => setIsVendorDetailsDrawerOpen(false)}
					vendorDetails={vendorDetails}
				/>
			}
			{isCreditNoteAutoSave && (
				<AutoSaveModal
					isOpenModel={isCreditNoteAutoSave}
					setIsOpenModel={setIsCreditNoteAutoSave}
					user={user}
					permission={'purchases.credit_notes.create'}
					type={'Credit Note'}
					withoutSave={() => {
						setIsLocationBlocker(false);
						setIsCreditNoteAutoSave(false);
						setTimeout(() => {
							navigate(isNextLocation.nextLocation?.pathname);
						}, 300);
					}}
					SaveAsContinue={() => {
						setIsCreditNoteAutoSave(false);
						handleSaveCreditNote(1);
					}}
				/>
			)}
			{(isOpenPastDate || isOpenCNPastDate) && (
				<Modal
					className="delivery-modal"
					title="Confirm Past Date"
					isOpen={isOpenPastDate === false ? isOpenCNPastDate : isOpenPastDate}
					onClose={() => cancelUsedPastDate()}
					cancelButton={true}
				>
					<p>You are creating a transaction in the past date. Do you want to continue?</p>

					<div
						style={{
							display: 'flex',
							flexDirection: 'row',
							justifyContent: 'flex-start',
							marginTop: '20px',
						}}
					>
						<Button
							button="Proceed"
							type="button"
							className="btn btn-primary"
							onClick={isOpenPastDate ? confirmUsedPastDate : confirmUsedCNPastDate}
						/>
						<span style={{ width: '20px' }}></span>
						<Button
							button="Cancel"
							type="button"
							className="btn btn-danger"
							onClick={() => cancelUsedPastDate()}
						/>
					</div>
				</Modal>
			)}
			<VendorDetailsDrawer
				isOpen={isVendorDetailsDrawerOpen}
				onClose={() => setIsVendorDetailsDrawerOpen(false)}
				vendor_id={creditNoteFormData.vendor_id}
				vendorDetailsDrawerActiveOpenTab={vendorDetailsDrawerActiveOpenTab}
			/>
		</div>
	);
};

export default CreateCreditNote;
